import axios from 'axios';

export const workflowContainerFullApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/workflow-container-full`,
    headers: {
        'Content-Type': 'application/json'
    }
})